import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { Column } from 'primereact/column'
import { InputSwitch } from 'primereact/inputswitch'
import { Button } from 'primereact/button'
import { Link } from 'react-router-dom'
import { PrimeIcons } from 'primereact/api'

import { RootState } from '../../redux/store'
import { dateLocalize } from '../../../lib/date-localize'
import { Table } from '../../../common/uikit/Table'
import { isPartnerDomain } from '../../../lib/currentDomain'
import { useAlarmQuery } from '../../../common/hooks/useFetchEndpoints'
import { usePartnerSetAcknowledgedMutation, Alarm } from '../../../common/redux/api/web-api'
import useText from '../../../common/hooks/useText'
import { Input } from '../../../common/uikit/Input'

export const DashboardAlarmsWidget = () => {
    const text = useText()
    const { partnerId } = useSelector((state: RootState) => state.user)
    const [showConfirmed, setShowConfirmed] = useState(false)
    const { data: alarms, isLoading: isLoadingAlarms } = useAlarmQuery(partnerId, showConfirmed)

    const [globalFilter, setGlobalFilter] = useState('')

    const [acknowledgeAlarm] = usePartnerSetAcknowledgedMutation()

    return (
        <>
            <div className="flex align-items-center justify-content-between mb-4">
                {isPartnerDomain && (
                    <div className="flex align-items-center">
                        <InputSwitch
                            checked={showConfirmed ?? undefined}
                            onChange={(e) => setShowConfirmed(e.value)}
                            inputId="input-show-confirmed"
                            name="show-confirmed"
                        />
                        <label htmlFor="input-show-confirmed" className="m-0 ml-2">
                            {text('lblShowConfirmedField')}
                        </label>
                    </div>
                )}

                <Input
                    id="alarms-search-input"
                    type="search"
                    value={globalFilter}
                    onChange={(e) => setGlobalFilter(e.target.value)}
                    placeholder={text('msgSearch')}
                    icon={PrimeIcons.SEARCH}
                    data-testid="alarms-search-input"
                />
            </div>
            <Table
                value={alarms}
                size="normal"
                loading={isLoadingAlarms}
                globalFilter={globalFilter}
                globalFilterFields={[
                    'alarmDefinition.name',
                    'alarmDefinition.description',
                    'company.name',
                    'chargePointId',
                ]}
                dataKey="id"
                paginator
                rows={10}
                emptyMessage={text('msgNoAlarmsFound')}
                data-testid="alarms-table"
            >
                <Column
                    field="chargePointId"
                    header={text('lblSerialNumberShort')}
                    body={(alarm: Alarm) => {
                        return (
                            <Link className="pr-4" to={`/chargepoints/${alarm.chargePointId}`}>
                                {alarm.chargePointId}
                            </Link>
                        )
                    }}
                ></Column>
                <Column field="company.name" header={text('lblOrganisation')}></Column>
                <Column
                    field="lastOccurence"
                    header={text('lblTime')}
                    body={(alarm) => dateLocalize(alarm.lastOccurence)}
                ></Column>

                <Column field="alarmDefinition.name" header={text('lblType')}></Column>
                <Column field="noOfOccurences" header="#"></Column>
                <Column field="alarmDefinition.description" header={text('lblDescription')} className="w-2 "></Column>

                {isPartnerDomain ? (
                    <Column
                        field="acknowledged"
                        header={text('lblConfirm')}
                        body={(alarm: Alarm) =>
                            alarm.acknowledged ? (
                                dateLocalize(alarm.acknowledged)
                            ) : (
                                <Button
                                    size="small"
                                    rounded
                                    icon="pi pi-check"
                                    title={text('btnConfirm')}
                                    onClick={() => acknowledgeAlarm({ alarmId: alarm.id!, partnerId: partnerId! })}
                                ></Button>
                            )
                        }
                    ></Column>
                ) : (
                    <Column
                        field="acknowledged"
                        header={text('lblConfirm')}
                        body={(alarm: Alarm) =>
                            alarm.acknowledged ? dateLocalize(alarm.acknowledged) : <span>---</span>
                        }
                    ></Column>
                )}
            </Table>
        </>
    )
}
